import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage, translateUrl } from '../context/LanguageContext';

export default function SEO({ title, description, canonical, ogType = 'website', ogImage }) {
  const { lang } = useLanguage();
  const location = useLocation();
  const siteName = "Porthos Maritime";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDesc = lang === 'da' 
    ? "Porthos Maritime leverer professionel rådgivning og operativ support til komplekse projekter i den maritime sektor, herunder offshore vind, logistik og marine operationer."
    : "Porthos Maritime delivers professional advisory and operational support for complex projects in the maritime sector, including offshore wind, logistics, and marine operations.";
  const desc = description || defaultDesc;
  
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://porthos-maritime.dk';
  const currentPath = location.pathname;
  
  // Canonical URL
  const canonicalUrl = canonical || `${origin}${currentPath}`;
  
  // Hreflang URLs
  const daUrl = `${origin}${translateUrl(currentPath, 'da')}`;
  const enUrl = `${origin}${translateUrl(currentPath, 'en')}`;

  const defaultOgImage = "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/3d1daa2f-9c30-44a3-8a4a-e93858eb73cd.png";
  const image = ogImage || defaultOgImage;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Hreflang tags for multi-language SEO */}
      <link rel="alternate" hrefLang="da" href={daUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={daUrl} /> {/* Danish is primary */}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </>
  );
}
